import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';

export class TopBarButton extends PureComponent {
  static propTypes = {
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    updateTopBarExpendedMenu: PropTypes.func.isRequired,
    updateTopBarButtonMenuTriggeredClick: PropTypes.func.isRequired,
    expandedMenu: PropTypes.string,
    isExpandedMenuTriggeredClick: PropTypes.bool,
    menu: PropTypes.string.isRequired,
    className: PropTypes.string,
    badge: PropTypes.node,
    onMount: PropTypes.func,
    onUnMount: PropTypes.func,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
  };

  static defaultProps = {
    className: null,
    badge: null,
    expandedMenu: null,
    isExpandedMenuTriggeredClick: false,
    onMount: null,
    onUnMount: null,
    onClick: null,
    onMouseEnter: null,
  };

  componentDidMount() {
    const { onMount } = this.props;

    if (onMount) {
      onMount();
    }
  }

  componentWillUnmount() {
    const { onUnMount } = this.props;

    if (onUnMount) {
      onUnMount();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      menu,
      expandedMenu,
      updateTopBarButtonMenuTriggeredClick,
    } = this.props;

    const prevPropsSelected = prevProps.expandedMenu === prevProps.menu;
    const selected = expandedMenu === menu;

    if (selected !== prevPropsSelected) {
      // This is to avoid the outline on the button right after the dropdown is expanded
      updateTopBarButtonMenuTriggeredClick(true);
    }
  }

  onClick = (e) => {
    const { updateTopBarExpendedMenu, menu, onClick } = this.props;

    updateTopBarExpendedMenu(menu);

    if (onClick) {
      onClick(e);
    }
  };

  onBlur = () => {
    const { updateTopBarButtonMenuTriggeredClick } = this.props;

    updateTopBarButtonMenuTriggeredClick(false);
  };

  onMouseEnter = (e) => {
    const { onMouseEnter } = this.props;

    if (onMouseEnter) {
      onMouseEnter(e);
    }
  };

  render() {
    const {
      icon,
      label,
      className,
      badge,
      expandedMenu,
      menu,
      isExpandedMenuTriggeredClick,
    } = this.props;

    const selected = expandedMenu === menu;

    return (
      <top-bar-button>
        <button
          type="button"
          className={classNames('top-bar-button', className, {
            'top-bar-button-selected': selected,
            'top-bar-button-triggered-clicked': isExpandedMenuTriggeredClick,
          })}
          onClick={this.onClick}
          onBlur={this.onBlur}
          onMouseEnter={this.onMouseEnter}
          aria-haspopup="true"
          aria-expanded={selected}
        >
          {icon}
          <span className="top-bar-button-label">{label}</span>{' '}
          {badge && <span className="top-bar-button-badge">{badge}</span>}
        </button>
      </top-bar-button>
    );
  }
}
